import { ArrowRight, ShieldCheck, Sparkles } from "lucide-react";

function scrollToId(id) {
    const el = document.getElementById(id);
    if (!el) return;
    const paddingTop = parseFloat(getComputedStyle(el).paddingTop) || 0;
    const top = el.getBoundingClientRect().top + window.scrollY - 80 + paddingTop - 24;
    window.scrollTo({ top, behavior: "smooth" });
}

export default function Hero() {
    return (
        <section
            id="home"
            data-testid="hero-section"
            className="relative min-h-[100svh] flex items-center overflow-hidden pt-32 sm:pt-36 pb-16"
        >
            {/* Background — only show image in dark mode */}
            <div className="absolute inset-0">
                <img
                    src="https://static.prod-images.emergentagent.com/jobs/1de6921e-0f9a-4486-8976-478177194c04/images/931314bfca849ddb1bc0fd35c8b164fe2304f099dce1af478b32246a0c8acb18.png"
                    alt=""
                    className="hidden dark:block w-full h-full object-cover opacity-60"
                />
                {/* Dark mode overlay */}
                <div className="hidden dark:block absolute inset-0 bg-gradient-to-b from-black/40 via-black/70 to-[#050505]" />
                {/* Light mode background */}
                <div className="dark:hidden absolute inset-0 bg-gradient-to-b from-white via-zinc-50 to-white" />
                {/* Glows */}
                <div className="absolute -top-32 -left-32 w-[36rem] h-[36rem] rounded-full bg-[#E89546]/15 dark:bg-[#E89546]/10 blur-3xl" />
                <div className="absolute bottom-0 right-0 w-[30rem] h-[30rem] rounded-full bg-[#2DA89E]/15 dark:bg-[#2DA89E]/10 blur-3xl" />
            </div>

            <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 w-full">
                <div className="max-w-3xl reveal">
                    <span
                        data-testid="hero-overline"
                        className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.22em] text-[#E89546]"
                    >
                        <Sparkles className="w-3.5 h-3.5" /> Gestão de Serviços
                    </span>
                    <h1
                        data-testid="hero-title"
                        className="font-heading mt-5 text-4xl sm:text-5xl lg:text-7xl font-black tracking-tighter text-zinc-950 dark:text-white leading-[1.02]"
                    >
                        Operação impecável.
                        <br />
                        <span className="text-zinc-500 dark:text-zinc-400">Resultado</span>{" "}
                        <span className="text-[#E89546]">consistente.</span>
                    </h1>
                    <p
                        data-testid="hero-subtitle"
                        className="mt-6 text-base sm:text-lg text-zinc-700 dark:text-zinc-300 max-w-2xl leading-relaxed"
                    >
                        A GOODMAX entrega soluções operacionais sob medida em
                        limpeza, manutenção predial, portaria, vigia, recepção
                        e apoio a eventos — para órgãos públicos e empresas
                        privadas em todo o território nacional.
                    </p>

                    <div className="mt-10 flex flex-col sm:flex-row gap-3">
                        <button
                            data-testid="hero-cta-servicos"
                            onClick={() => scrollToId("servicos")}
                            className="group inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-[#E89546] text-black font-semibold transition-transform hover:bg-[#f0a25b] active:scale-95"
                        >
                            Conheça nossos serviços
                            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                        </button>
                        <button
                            data-testid="hero-cta-contato"
                            onClick={() => scrollToId("contato")}
                            className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full border border-zinc-300 dark:border-white/15 text-zinc-900 dark:text-white hover:bg-zinc-100 dark:hover:bg-white/5 transition-colors active:scale-95"
                        >
                            Fale com um especialista
                        </button>
                    </div>

                    <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 gap-6 max-w-2xl">
                        <Metric value="+10" label="Setores atendidos" />
                        <Metric value="100%" label="Operações monitoradas" />
                        <Metric value="BR" label="Atuação em todo território nacional" />
                    </div>
                </div>
            </div>

            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2 text-xs text-zinc-600 dark:text-zinc-500">
                <ShieldCheck className="w-4 h-4 text-[#2DA89E]" /> Ética · Transparência · Melhoria contínua
            </div>
        </section>
    );
}

function Metric({ value, label }) {
    return (
        <div data-testid={`hero-metric-${label.toLowerCase().replace(/\s+/g, "-")}`}>
            <div className="font-heading text-3xl sm:text-4xl font-black text-zinc-950 dark:text-white">
                {value}
            </div>
            <div className="text-xs sm:text-sm text-zinc-600 dark:text-zinc-400 mt-1">{label}</div>
        </div>
    );
}
